export default __webpack_public_path__ + "static/media/newLogo.e18f758f.png";